module.exports = __webpack_public_path__ + "img/bottomline_strict.8394f25e.png";